/**
 * Sentry must load before React. Imported first from index.js.
 * Enabled when REACT_APP_SENTRY_DSN is set (same idea as backend SENTRY_DSN).
 */
import * as Sentry from "@sentry/react";

import { environment } from "./config/environment";

function buildTracePropagationTargets() {
  const targets = ["localhost", "127.0.0.1", /^https:\/\/.+\.railway\.app$/];
  try {
    const origin = new URL(environment.backendUrl).origin;
    if (origin) targets.push(origin);
  } catch {
    // ignore invalid backendUrl
  }
  return targets;
}

function beforeSend(event, hint) {
  const err = hint?.originalException;
  const msg =
    (typeof err?.message === "string" && err.message) ||
    (typeof event?.message === "string" && event.message) ||
    event?.logentry?.message ||
    "";
  if (typeof msg === "string" && msg.includes("ResizeObserver loop")) {
    return null;
  }
  return event;
}

if (environment.sentryDsn) {
  const release =
    (process.env.REACT_APP_SENTRY_RELEASE || "").trim() ||
    (process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA || "").trim() ||
    undefined;

  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    tracesSampleRate: environment.sentryTracesSampleRate,
    integrations: [
      Sentry.browserTracingIntegration({
        tracePropagationTargets: buildTracePropagationTargets(),
      }),
    ],
    beforeSend,
    release: release || undefined,
    sendDefaultPii: false,
  });
}
